import HistoryModal, { HISTORY_MODAL, HistoryModalTrigger } from './HistoryModal'

export { HISTORY_MODAL, HistoryModalTrigger }
export default HistoryModal
